
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';


const methods = [
  {
    label: 'Address',
    value: (
        <Typography variant="body1">John W. McCormack Building <br />
          One Ashburton Place, Room 411 <br />
          Boston, MA 02108
        </Typography>
    ),
    icon: (
     <LocationOnIcon fontSize='small'/>
    ),
  },
  {
    label: 'Hours',
    value: (
        <Stack>
            <Typography variant="body1">Monday - Friday: 8:30 a.m. to 4:30 p.m.</Typography>
            <Typography variant="body1">Walk-In: Tuesday, Wednesday, Thursday</Typography>
            <Typography variant="body1">By Appointment: Monday, Friday</Typography>
        </Stack>
    ),
    icon: (
     <QueryBuilderIcon fontSize='small'/>
    ),
  },
  {
    label: 'Main Line',
    value: (
        <>
            <Typography variant='body1'>617-979-8300</Typography>
            <Link variant='body2' underline='hover' href="/About/ContactUs"><i>Staff Directory</i></Link>
        </>
    ),
    icon: (
      <LocalPhoneIcon fontSize='small' />
    ),
  },
  {
    label: 'Email',
    value: (
        <Stack direction="row">
            <Typography variant="body1">ocpf</Typography>
            <AlternateEmailIcon sx={{ fontSize: 18, padding: 0.2, marginTop: 0.5 }} />
            <Typography variant="body1">mass.gov</Typography>
        </Stack>
    ),
    icon: (
      <EmailIcon fontSize='small'/>
    ),
  },
];


const Contact = (): JSX.Element => {
  const theme = useTheme();
  
  return (
    <Box>
      <Box marginBottom={3} marginTop={3}>
        <Typography
          variant={'h4'}
          sx={{ fontWeight: 700 }}
          gutterBottom
          align={'center'}
        >
          Contact Us
        </Typography>
      </Box>
      <Box
        display={'flex'}
        flexDirection={{ xs: 'column', md: 'row' }}
        justifyContent={'space-between'}
        marginBottom={4}
      >
        {methods.map((item, i) => (
          <Box
            key={i}
            component={ListItem}
            disableGutters
            width={'auto'}
            padding={0}
          >
            <Box
              component={ListItemAvatar}
              minWidth={'auto !important'}
              marginRight={2}
            >
              <Box
                component={Avatar}
                bgcolor={theme.palette.secondary.main}
                width={40}
                height={40}
              >
                {item.icon}
              </Box>
            </Box>
            <ListItemText 
                primary={
                    <Typography variant="body2" color="text.secondary">{item.label}</Typography>
                } 
                secondary={<Typography variant="body1">{item.value}</Typography>} 
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Contact;
